"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const rxjs_1 = require("rxjs");
const errors_1 = require("@ledgerhq/errors");
const deviceAccess_1 = require("../../hw/deviceAccess");
const operation_1 = require("../../operation");
const js_buildTransaction_1 = require("./js-buildTransaction");
const ledgerjs_hw_app_cardano_1 = __importStar(require("@cardano-foundation/ledgerjs-hw-app-cardano"));
const typhonjs_1 = require("@stricahq/typhonjs");
const logic_1 = require("./logic");
const ShelleyTypeAddress_1 = __importDefault(require("@stricahq/typhonjs/dist/address/ShelleyTypeAddress"));
const networks_1 = require("./networks");
const constants_1 = require("./constants");
const tx_helpers_1 = require("./tx-helpers");
const currencies_1 = require("../../currencies");
const types_1 = require("@stricahq/typhonjs/dist/types");
const buildOptimisticOperation = (account, transaction, t) => {
    var _a;
    const cardanoResources = account.cardanoResources;
    const accountCreds = new Set([...cardanoResources.externalCredentials, ...cardanoResources.internalCredentials].map(cred => cred.key));
    const stakeCredential = (0, logic_1.getAccountStakeCredential)(account.xpub, account.index);
    const protocolParams = account.cardanoResources.protocolParams;
    const accountInput = transaction
        .getInputs()
        .reduce((total, i) => accountCreds.has(i.address.paymentCredential.hash) ? total.plus(i.amount) : total.plus(0), new bignumber_js_1.BigNumber(0));
    const accountOutput = transaction
        .getOutputs()
        .reduce((total, o) => o.address instanceof ShelleyTypeAddress_1.default &&
        accountCreds.has(o.address.paymentCredential.hash)
        ? total.plus(o.amount)
        : total.plus(0), new bignumber_js_1.BigNumber(0));
    const txCertificates = transaction.getCertificates();
    const stakeRegistrationCertificates = txCertificates.filter(c => c.certType === typhonjs_1.types.CertificateType.STAKE_REGISTRATION);
    const stakeDeRegistrationCertificates = txCertificates.filter(c => c.certType === typhonjs_1.types.CertificateType.STAKE_DE_REGISTRATION);
    const txWithdrawals = transaction.getWithdrawals();
    const transactionHash = transaction.getTransactionHash().toString("hex");
    const auxiliaryData = transaction.getAuxiliaryData();
    const extra = {};
    if (auxiliaryData) {
        const memoMetadata = auxiliaryData.metadata.find(m => m.label === constants_1.MEMO_LABEL);
        if (memoMetadata && memoMetadata.data instanceof Map) {
            const msg = memoMetadata.data.get("msg");
            if (Array.isArray(msg) && msg.length) {
                extra.memo = msg.join(", ");
            }
        }
    }
    let operationValue = accountOutput.minus(accountInput);
    if (stakeRegistrationCertificates.length) {
        const walletRegistration = stakeRegistrationCertificates.find(c => c.stakeCredential.type === types_1.HashType.ADDRESS &&
            c.stakeCredential.hash === stakeCredential.key);
        if (walletRegistration) {
            extra.deposit = (0, currencies_1.formatCurrencyUnit)(account.currency.units[0], new bignumber_js_1.BigNumber(protocolParams.stakeKeyDeposit), {
                showCode: true,
                disableRounding: true,
            });
        }
    }
    if (stakeDeRegistrationCertificates.length) {
        const walletDeRegistration = stakeDeRegistrationCertificates.find(c => c.stakeCredential.type === types_1.HashType.ADDRESS &&
            c.stakeCredential.hash === stakeCredential.key);
        if (walletDeRegistration) {
            operationValue = operationValue.minus(protocolParams.stakeKeyDeposit);
            extra.refund = (0, currencies_1.formatCurrencyUnit)(account.currency.units[0], new bignumber_js_1.BigNumber(protocolParams.stakeKeyDeposit), {
                showCode: true,
                disableRounding: true,
            });
        }
    }
    if (txWithdrawals && txWithdrawals.length) {
        const walletWithdraw = txWithdrawals.find(w => w.rewardAccount.stakeCredential.type === types_1.HashType.ADDRESS &&
            w.rewardAccount.stakeCredential.hash === stakeCredential.key);
        if (walletWithdraw) {
            operationValue = operationValue.minus(walletWithdraw.amount);
            extra.rewards = (0, currencies_1.formatCurrencyUnit)(account.currency.units[0], new bignumber_js_1.BigNumber(walletWithdraw.amount), {
                showCode: true,
                disableRounding: true,
            });
        }
    }
    const opType = txCertificates.find(c => c.certType === typhonjs_1.types.CertificateType.STAKE_DELEGATION)
        ? "DELEGATE"
        : txCertificates.find(c => c.certType === typhonjs_1.types.CertificateType.STAKE_DE_REGISTRATION)
            ? "UNDELEGATE"
            : (0, logic_1.getOperationType)({
                valueChange: operationValue,
                fees: transaction.getFee(),
            });
    const op = {
        id: (0, operation_1.encodeOperationId)(account.id, transactionHash, opType),
        hash: transactionHash,
        type: opType,
        value: operationValue.absoluteValue(),
        fee: transaction.getFee(),
        blockHash: undefined,
        blockHeight: null,
        senders: transaction.getInputs().map(i => i.address.getBech32()),
        recipients: transaction.getOutputs().map(o => o.address.getBech32()),
        accountId: account.id,
        date: new Date(),
        extra,
    };
    const tokenAccount = t.subAccountId
        ? (_a = account.subAccounts) === null || _a === void 0 ? void 0 : _a.find(ta => ta.id === t.subAccountId)
        : null;
    if (tokenAccount && opType === "OUT") {
        op.subOperations = [
            {
                id: (0, operation_1.encodeOperationId)(tokenAccount.id, transactionHash, opType),
                hash: transactionHash,
                type: opType,
                value: t.useAllAmount ? tokenAccount.balance : t.amount,
                fee: t.fees,
                blockHash: undefined,
                blockHeight: null,
                senders: transaction.getInputs().map(i => i.address.getBech32()),
                recipients: transaction.getOutputs().map(o => o.address.getBech32()),
                accountId: tokenAccount.id,
                date: new Date(),
                extra: {},
            },
        ];
    }
    return op;
};
/**
 * Adds signatures to unsigned transaction
 */
const signTx = (unsignedTransaction, accountKey, witnesses) => {
    witnesses.forEach(witness => {
        const [, , , chainType, index] = witness.path;
        const publicKey = accountKey.derive(chainType).derive(index).toPublicKey().toBytes();
        const vKeyWitness = {
            signature: Buffer.from(witness.witnessSignatureHex, "hex"),
            publicKey: Buffer.from(publicKey),
        };
        unsignedTransaction.addWitness(vKeyWitness);
    });
    return unsignedTransaction.buildTransaction();
};
/**
 * Sign Transaction with Ledger hardware
 */
const signOperation = ({ account, deviceId, transaction }) => (0, deviceAccess_1.withDevice)(deviceId)(transport => new rxjs_1.Observable(o => {
    function main() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            o.next({ type: "device-signature-requested" });
            if (!transaction.fees) {
                throw new errors_1.FeeNotLoaded();
            }
            const unsignedTransaction = yield (0, js_buildTransaction_1.buildTransaction)(account, transaction);
            const accountPubKey = (0, logic_1.getExtendedPublicKeyFromHex)(account.xpub);
            const rawInputs = unsignedTransaction.getInputs();
            const ledgerAppInputs = rawInputs.map(i => (0, tx_helpers_1.prepareLedgerInput)(i, account.index));
            const rawOutptus = unsignedTransaction.getOutputs();
            const ledgerAppOutputs = rawOutptus.map(o => (0, tx_helpers_1.prepareLedgerOutput)(o, account.index));
            const rawCertificates = unsignedTransaction.getCertificates();
            const ledgerCertificates = rawCertificates.map(rcert => {
                if (rcert.certType === ledgerjs_hw_app_cardano_1.CertificateType.STAKE_REGISTRATION) {
                    return (0, tx_helpers_1.prepareStakeRegistrationCertificate)(rcert);
                }
                else if (rcert.certType === ledgerjs_hw_app_cardano_1.CertificateType.STAKE_DELEGATION) {
                    return (0, tx_helpers_1.prepareStakeDelegationCertificate)(rcert);
                }
                else if (rcert.certType === ledgerjs_hw_app_cardano_1.CertificateType.STAKE_DEREGISTRATION) {
                    return (0, tx_helpers_1.prepareStakeDeRegistrationCertificate)(rcert);
                }
                else {
                    throw new Error("Invalid Certificate type");
                }
            });
            const rawWithdrawals = unsignedTransaction.getWithdrawals();
            const ledgerWithdrawals = rawWithdrawals.map(tx_helpers_1.prepareWithdrawal);
            const auxiliaryDataHashHex = unsignedTransaction.getAuxiliaryDataHashHex();
            const networkParams = (0, networks_1.getNetworkParameters)(account.currency.id);
            const network = networkParams.networkId === ledgerjs_hw_app_cardano_1.Networks.Mainnet.networkId
                ? ledgerjs_hw_app_cardano_1.Networks.Mainnet
                : ledgerjs_hw_app_cardano_1.Networks.Testnet;
            const trxOptions = {
                signingMode: ledgerjs_hw_app_cardano_1.TransactionSigningMode.ORDINARY_TRANSACTION,
                tx: {
                    network,
                    inputs: ledgerAppInputs,
                    outputs: ledgerAppOutputs,
                    certificates: ledgerCertificates,
                    withdrawals: ledgerWithdrawals,
                    fee: unsignedTransaction.getFee().toString(),
                    ttl: (_a = unsignedTransaction.getTTL()) === null || _a === void 0 ? void 0 : _a.toString(),
                    validityIntervalStart: null,
                    auxiliaryData: auxiliaryDataHashHex
                        ? {
                            type: ledgerjs_hw_app_cardano_1.TxAuxiliaryDataType.ARBITRARY_HASH,
                            params: {
                                hashHex: auxiliaryDataHashHex,
                            },
                        }
                        : null,
                },
                additionalWitnessPaths: [],
            };
            // Sign by device
            const appAda = new ledgerjs_hw_app_cardano_1.default(transport);
            const r = yield appAda.signTransaction(trxOptions);
            const signed = signTx(unsignedTransaction, accountPubKey, r.witnesses);
            o.next({ type: "device-signature-granted" });
            const operation = buildOptimisticOperation(account, unsignedTransaction, transaction);
            o.next({
                type: "signed",
                signedOperation: {
                    operation,
                    signature: signed.payload,
                },
            });
        });
    }
    main().then(() => o.complete(), e => o.error(e));
}));
exports.default = signOperation;
//# sourceMappingURL=js-signOperation.js.map